module.exports = __webpack_public_path__ + "static/img/contant_2.9ecac0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/contant_2.png
// module id = ghdA
// module chunks = 0